import { Controller } from "stimulus"
import './component.scss'

class PressroomHeaderSpController extends Controller {
  static targets = ["drawer", "overlay"]

  open() {
    document.body.style.overflow = 'hidden'
    this.drawerTarget.classList.add('is-open')
    this.overlayTarget.classList.add('is-open')
  }

  close() {
    document.body.style.overflow = ''
    this.drawerTarget.classList.remove('is-open')
    this.overlayTarget.classList.remove('is-open')
  }
}

window.Stimulus.register('pressroom-header-sp', PressroomHeaderSpController)
